import type { DeploymentDto } from "@superblocksteam/shared";

import { Slice } from "store/utils/slice";
import type { EntitiesStateWithMeta } from "store/utils/types";

type DeploymentsState = EntitiesStateWithMeta<DeploymentDto, any>;

export default new Slice<DeploymentsState>("deployments", {
  entities: {},
  loading: {},
  errors: {},
  meta: {},
});
